import React from 'react'
import styles from './style.module.scss'
import PropTypes from 'prop-types'

const StatCard = ({ title, teamA, teamB, score, wickets, overs, winner, label }) =>
  (<>
  <div className='d-flex flex-row justify-content-between align-items-center mt-3'>
    <div className={`d-flex flex-column justify-content-start gap-2 ${styles.teamData}`} >
      <div className={`${styles.text} text-uppercase fw-bolder`}>{teamA} <span className='text-lowercase'>{' vs '}</span> {teamB}</div>
      {overs ? (<div><span className='fw-bolder'>{score}/{wickets} <span style={{ fontWeight: '500' }}>{`(${overs} overs)`}</span></span></div>) : ''}
    </div>
    <div>
      <span className={styles.text} style={{ color: '#9D9D9D' }}> {winner ? (<>
        {'Won by '}<span className='text-uppercase'> {winner}</span>
      </>) : '--'}
      </span>
    </div>
    <div className={`d-flex justify-content-end ${styles.teamData}`} >
      {label ? <span className={styles.text}>{label}</span> : '--'}
    </div>
  </div>
</>
  )

const VenueStats = ({ data }) => {
  const getTeamName = (match, teamScoreA, teamScoreB) =>
    match.iWinnerId === teamScoreA.iTeamId ? teamScoreA.oTeam.sAbbr : match.iWinnerId === teamScoreB.iTeamId ? teamScoreB.oTeam.sAbbr : ''

  const getWinnersOver = (match, teamScoreA, teamScoreB) =>
    match.iWinnerId === teamScoreA.iTeamId ? teamScoreA.sOvers : match.iWinnerId === teamScoreB.iTeamId ? teamScoreB.sOvers : ''
  return (
    <>
      <h6>Venue Stats</h6>
      <div className={styles.common_border}>
        <div className={`d-flex flex-row justify-content-between align-items-center m-4 ${styles.head}`}>
          <div className={`${styles.heading}`}><span >{data?.nTotalMatches} Matches</span></div>
          <div className='d-flex flex-row gap-4 gap-1-sm'>
            <span className={`${styles.firstWin}`}><span className={`${styles.text}`}>Win Bat first </span><span className={styles.greenText}>{data?.nFirstBatWin !== undefined ? `${'  '}  ${(data.nFirstBatWin / data.nTotalMatches * 100).toFixed(2)}%` : '--'}</span></span>
            <span className={`${styles.firstWin}`}><span className={`${styles.text}`}>Win Bowl first  </span><span className={styles.greenText}>{data?.nFirstBowlWin !== undefined ? `${'  '}  ${(data.nFirstBowlWin / data.nTotalMatches * 100).toFixed(2)}%` : '--'}</span></span>
          </div>
        </div>
        <div className={styles.line}></div>
        <div className={styles.spacing}>
          {data?.aStatsPerInning && <div className='d-flex flex-row justify-content-between w-100 pt-3'>
            {data?.aStatsPerInning ? data?.aStatsPerInning.map((inning, index) => (
              <div className='d-flex flex-column gap-1 align-items-center' key={index}>
                <span className={styles.text}>Avg {inning.nInningNumber || ''} Innings</span>
                <span style={{ fontWeight: '700' }}>{inning.nAvgRuns || ''}</span>
              </div>
            )) : ''}
          </div>}
          {data?.oHighestScore?.oMatch?.iWinnerId !== null ? (
            <>
              <div className={styles.line}></div>
              {data?.oHighestScore?.iMatchId !== null ? (<>
                <StatCard
                  title="Highest Score"
                  teamA={data?.oHighestScore?.oMatch?.oTeamScoreA?.oTeam?.sAbbr}
                  teamB={data?.oHighestScore?.oMatch?.oTeamScoreB?.oTeam?.sAbbr}
                  score={data?.oHighestScore?.nScore}
                  wickets={data?.oHighestScore?.nWickets}
                  overs={getWinnersOver(data?.oHighestScore?.oMatch, data?.oHighestScore?.oMatch?.oTeamScoreA, data?.oHighestScore?.oMatch?.oTeamScoreB)}
                  winner={getTeamName(data?.oHighestScore?.oMatch, data?.oHighestScore?.oMatch?.oTeamScoreA, data?.oHighestScore?.oMatch?.oTeamScoreB)}
                  label="Highest"
                />
                {data?.oLowestScore?.iMatchId !== null && <div className={styles.line}></div>}
              </>) : ''}
              {data?.oLowestScore?.iMatchId !== null ? (<>
                <StatCard
                  title="Lowest Score"
                  teamA={data?.oLowestScore?.oMatch?.oTeamScoreA?.oTeam?.sAbbr}
                  teamB={data?.oLowestScore?.oMatch?.oTeamScoreB?.oTeam?.sAbbr}
                  score={data?.oLowestScore?.nScore}
                  wickets={data?.oLowestScore?.nWickets}
                  overs={getWinnersOver(data?.oLowestScore?.oMatch, data?.oLowestScore?.oMatch?.oTeamScoreA, data?.oLowestScore?.oMatch?.oTeamScoreB)}
                  winner={getTeamName(data?.oLowestScore?.oMatch, data?.oLowestScore?.oMatch?.oTeamScoreA, data?.oLowestScore?.oMatch?.oTeamScoreB)}
                  label="Lowest"
                />
                {(data?.oHighestScoreChased?.iMatchId !== null || data?.oLowestScoreDefended?.iMatchId !== null) && <div className={styles.line}></div>}
              </>) : ''}
              {data?.oHighestScoreChased?.iMatchId !== null ? (<>
                <StatCard
                  title="Highest Score Chased"
                  teamA={data?.oHighestScoreChased?.oMatch?.oTeamScoreA?.oTeam?.sAbbr}
                  teamB={data?.oHighestScoreChased?.oMatch?.oTeamScoreB?.oTeam?.sAbbr}
                  score={data?.oHighestScoreChased?.nScore}
                  wickets={data?.oHighestScoreChased?.nWickets}
                  overs={getWinnersOver(data?.oHighestScoreChased?.oMatch, data?.oHighestScoreChased?.oMatch?.oTeamScoreA, data?.oHighestScoreChased?.oMatch?.oTeamScoreB)}
                  winner={getTeamName(data?.oHighestScoreChased?.oMatch, data?.oHighestScoreChased?.oMatch?.oTeamScoreA, data?.oHighestScoreChased?.oMatch?.oTeamScoreB)}
                  label="Highest Chased"
                />
                {data?.oLowestScoreDefended?.iMatchId !== null && <div className={styles.line}></div>}
              </>) : ''}
              {data?.oLowestScoreDefended?.iMatchId !== null ? (
                <StatCard
                  title="Lowest Score Defended"
                  teamA={data?.oLowestScoreDefended?.oMatch?.oTeamScoreA?.oTeam?.sAbbr}
                  teamB={data?.oLowestScoreDefended?.oMatch?.oTeamScoreB?.oTeam?.sAbbr}
                  score={data?.oLowestScoreDefended?.nScore}
                  wickets={data?.oLowestScoreDefended?.nWickets}
                  overs={getWinnersOver(data?.oLowestScoreDefended?.oMatch, data?.oLowestScoreDefended?.oMatch?.oTeamScoreA, data?.oLowestScoreDefended?.oMatch?.oTeamScoreB)}
                  winner={getTeamName(data?.oLowestScoreDefended?.oMatch, data?.oLowestScoreDefended?.oMatch?.oTeamScoreA, data?.oLowestScoreDefended?.oMatch?.oTeamScoreB)}
                  label="Lowest Defended"
                />) : ''}
            </>
          ) : ''}
        </div>
      </div>
    </>
  )
}

StatCard.propTypes = {
  title: PropTypes.string,
  teamA: PropTypes.string,
  teamB: PropTypes.string,
  score: PropTypes.number,
  wickets: PropTypes.number,
  overs: PropTypes.string,
  winner: PropTypes.string,
  label: PropTypes.string
}

VenueStats.propTypes = {
  data: PropTypes.array.isRequired
}

export default VenueStats
